import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';
import { List, ListItem, ListItemText, ListItemSecondaryAction, IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import ListManager from './list-manager.component';
import axios from 'axios';
import config from '../config';
import PropTypes from 'prop-types';
import InputAdornment from '@material-ui/core/InputAdornment';
import PlaylistAdd from '@material-ui/icons/PlaylistAdd';

const BACKEND_URL = config.backend.host;

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  leftIcon: {
    marginRight: theme.spacing(),
    fontSize: 20,
    background: '#F6227F'
  },
  button: {
    margin: theme.spacing(),
    background: '#F6227F'
  },
  title: {
    margin: theme.spacing()
  },
  gridFormType: {
    background: '#F5F5F5',
    padding: theme.spacing(),
  },
  listScroll:{
    maxHeight: 200, 
    overflow: 'auto',
  }
});

class ConfigPage extends Component {

  state = {
    formSelectedIndex: -1,
    textForm: '',
    textType: '',
    typeList:[],
    configList: {
      form_type: [],
      cannabinoid: [],
      terpene: [],
      usage_period: [],
      imgFileMaxSizeMB: '',
      vidFileMaxSizeMB: '',
    },
  }

  constructor(props){
    super(props);
    axios.get(BACKEND_URL + `/configuration`)
          .then(response => this.loadData(response.data))
          .catch(err => this.showError(err));
  }

  showError(err){
    let msg = ''; 
    if (err.response){
      msg = ' \nServer Message: ' + err.response.data.message
    }
    alert(err + msg);
  }

  loadData(data){
    this.setState({
      configList: data[0],
    });
  }

  updateFormList(){
    if (this.state.textForm.trim() !== ''){
      let newList = [...this.state.configList.form_type, {name: this.state.textForm.trim(), type:[]}];
      this.updateList('form_type', newList);
    }
  }

  updateTypeList(){
    if (this.state.textType.trim() !== ''){
      let selectedForm = this.state.configList.form_type[this.state.formSelectedIndex];
      selectedForm.type = [...selectedForm.type, {name: this.state.textType.trim()}]
      let confList = {...this.state.configList};
      this.setState({
        configList: confList, 
        typeList: selectedForm.type,
        textType: ''
      });
    }
  }

  updateTerpeneList(newList){
    this.updateList('terpene', newList);
  }
  
  updateCannabinoidList(newList){
    this.updateList('cannabinoid', newList);
  }

  updateUsagePeriodList(newList){
    this.updateList('usage_period', newList);
  }

  updateList(listName, newList){
    this.setState({
      configList: {
        ...this.state.configList,
        [listName]: newList,
      },
    });
  }

  handleChangeConfigList = field => event => {
    this.setState({ 
      configList:{
        ...this.state.configList,
        [field]: event.target.value 
      }
    });
  }

  handleChange = field => event => {
    this.setState({ 
        [field]: event.target.value
    });
  }

  btnSaveOnClick(e){
    e.preventDefault();
    
    var obj = this.state.configList;

    axios.put(BACKEND_URL + `/configuration/${obj._id}`, obj)
    .then(res => this.saveSuccess(res))
    .catch(err => this.showError(err));
  };

  saveSuccess(response){
    //TODO: Set a snack bar with Redux to show messages after saving
    alert("Saved");
  }

  listFormOnClick= (index, event) => {
    let newSubList = this.state.configList.form_type.filter(item => item.name === event.target.textContent)[0].type;
    this.setState({ 
      formSelectedIndex: index,
      typeList: newSubList,
    });
  };

  deleteForm(item){
    let configList = this.state.configList;
    configList.form_type = configList.form_type.filter(i => i.name !== item);
    let confList = {...this.state.configList};
      this.setState({
        configList: confList, 
      });
  }
  
  deleteType(item){
    let selectedForm = this.state.configList.form_type[this.state.formSelectedIndex];
    selectedForm.type = selectedForm.type.filter(i => i.name !== item);
    let confList = {...this.state.configList};
      this.setState({
        configList: confList, 
        typeList: selectedForm.type,
      });
  }

  render(){

    const { classes } = this.props;
    var listCountForm = 0;
    
    return(
      <div>
        <Grid align = "center" justify="space-evenly" container alignItems = "center">
          <Grid xs={8}>
            <Typography variant="h4">
              Configurations
            </Typography>
          </Grid>
        </Grid>
        <form className={classes.container} autoComplete="off">
          <Grid container>
            <Grid item xs={12}>
              <Button variant="contained" size="medium" className={classes.button} 
              name="btnSave" onClick={this.btnSaveOnClick.bind(this)} color="primary">
                <SaveIcon className={classes.leftIcon}/>
                Save
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Grid container className={classes.gridFormType}>
                <Grid item xs={6}>
                  <Typography variant="h6" className={classes.title}>
                    Forms:
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="h6" className={classes.title}>
                    Types:
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <TextField variant="outlined" style={{width:'98%', margin:10}} 
                    value={this.state.textForm} 
                    onChange={this.handleChange('textForm')}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label='Add'
                            onClick={this.updateFormList.bind(this)}
                          >
                            <PlaylistAdd />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <List className={classes.listScroll}>
                    { this.state.configList.form_type ?
                      this.state.configList.form_type.map( t => 
                      <ListItem key={t.name} 
                        onClick={this.listFormOnClick.bind(this, listCountForm)}
                        selected={this.state.formSelectedIndex === listCountForm++}
                      >
                        <ListItemText primary={t.name}/>
                        <ListItemSecondaryAction>
                          <IconButton aria-label="Delete" onClick={this.deleteForm.bind(this, t.name)}>
                            <DeleteIcon />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>
                      )
                      :''
                    }
                  </List>
                </Grid>
                <Grid item xs={6}>
                  <TextField variant="outlined" style={{width:'98%', margin:10}} 
                    value={this.state.textType} 
                    onChange={this.handleChange('textType')}
                    disabled={ this.state.formSelectedIndex < 0 }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label='Add'
                            disabled={ this.state.formSelectedIndex < 0 }
                            onClick={this.updateTypeList.bind(this)}
                          >
                            <PlaylistAdd />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                    <List className={classes.listScroll}>
                    { this.state.typeList ?
                        this.state.typeList.map( t => 
                        <ListItem key={t.name} 
                        >
                          <ListItemText primary={t.name}/>
                          <ListItemSecondaryAction>
                            <IconButton aria-label="Delete" onClick={this.deleteType.bind(this, t.name)}>
                              <DeleteIcon />
                            </IconButton>
                          </ListItemSecondaryAction>
                        </ListItem>
                        )
                        :''
                      }
                      </List>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="h6" className={classes.title}>
                Cannabinoids:
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="h6" className={classes.title}>
                Terpenes:
              </Typography>
            </Grid>
            <Grid item xs={6}>
                <ListManager className={classes.listScroll} id='lmCannabinoid' list={this.state.configList.cannabinoid} 
                  cbListUpdate={this.updateCannabinoidList.bind(this)}
                />
            </Grid>
            <Grid item xs={6}>
                <ListManager className={classes.listScroll} id='lmTerpene' list={this.state.configList.terpene} 
                  cbListUpdate={this.updateTerpeneList.bind(this)}
                />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" className={classes.title}>
                Usage Period:
              </Typography>
            </Grid>
            <Grid item xs={12}>
                <ListManager className={classes.listScroll} id='lmUsagePeriod' list={this.state.configList.usage_period} 
                  cbListUpdate={this.updateUsagePeriodList.bind(this)}
                />
            </Grid>
            <Grid item xs={6}>
              <TextField 
                id="tfImgMax" 
                label="Image Max Size MB"
                margin="normal" 
                variant="outlined"
                //style={{width:'98%', marginLeft:10}}
                value={this.state.configList.imgFileMaxSizeMB}
                onChange={this.handleChangeConfigList('imgFileMaxSizeMB').bind(this)}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField id="tfVidMax" label="Video Max Size MB"
                margin="normal" variant="outlined"
                value={this.state.configList.vidFileMaxSizeMB}
                onChange={this.handleChangeConfigList('vidFileMaxSizeMB').bind(this)}
              />
            </Grid>
          </Grid>
        </form>
      </div>
    );
  }
}

ConfigPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ConfigPage);